const lazyLooxSelector = '[data-iicase-lazy-loox]';

function finishLazyLooxLoading(container) {
  container.dataset.iicaseLooxState = 'ready';
  container.querySelector('[data-iicase-lazy-loox-placeholder]')?.remove();
}

function watchLazyLooxFrame(container) {
  let timeoutId;

  const checkFrame = () => {
    const frame = container.querySelector('#looxReviewsFrame');
    if (!(frame instanceof HTMLIFrameElement)) return false;

    const renderedHeight = Math.max(
      Number.parseFloat(frame.style.height) || 0,
      Number.parseFloat(frame.getAttribute('height')) || 0
    );
    if (renderedHeight <= 0) return false;

    window.clearTimeout(timeoutId);
    observer.disconnect();
    finishLazyLooxLoading(container);
    return true;
  };

  const observer = new MutationObserver(checkFrame);
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['height', 'style'],
    childList: true,
    subtree: true,
  });

  timeoutId = window.setTimeout(() => {
    observer.disconnect();
    finishLazyLooxLoading(container);
  }, 5000);

  checkFrame();
}

function hydrateLazyLoox(container) {
  if (!(container instanceof HTMLElement) || container.dataset.iicaseLooxState) return;

  const template = container.querySelector('template[data-iicase-lazy-loox-content]');
  if (!(template instanceof HTMLTemplateElement)) return;

  container.dataset.iicaseLooxState = 'loading';
  watchLazyLooxFrame(container);
  template.replaceWith(template.content.cloneNode(true));
}

function scrollToLazyLoox(container) {
  hydrateLazyLoox(container);
  window.requestAnimationFrame(() => {
    container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

function initializeLazyLoox() {
  const containers = Array.from(document.querySelectorAll(lazyLooxSelector));
  if (containers.length === 0) return;

  if (window.location.hash === '#looxReviewsFrame' || window.location.hash === '#looxReviews') {
    scrollToLazyLoox(containers[0]);
  }

  if (!('IntersectionObserver' in window)) {
    containers.forEach(hydrateLazyLoox);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrateLazyLoox(entry.target);
      });
    },
    { rootMargin: '700px 0px', threshold: 0 }
  );

  containers.forEach((container) => observer.observe(container));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLazyLoox, { once: true });
} else {
  initializeLazyLoox();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('a[href="#looxReviewsFrame"], a[href="#looxReviews"]');
  const container = document.querySelector(lazyLooxSelector);
  if (!link || !(container instanceof HTMLElement)) return;

  event.preventDefault();
  scrollToLazyLoox(container);
});
